<template>
    <el-select ref="prefectureSelect" @change="change" v-model="modelValue" placeholder="選択してください" :class="className" :disabled="disabled">
        <el-option v-for="p in prefectureMaster" :key="p.iso" :value="p.prefecture" :label="p.prefecture"></el-option>
    </el-select>
</template>

<script>
import { isIE } from '@/common/useragent'

export default {
  name: 'PrefectureSelect',
  props: [
    'value',
    'disabled',
    'changeAction',
    'prefectureMaster',
    'className'
  ],
  data () {
    return {
      modelValue: this.value
    }
  },
  mounted () {
    if (isIE()) {
      // IEでel-selectのプルダウンにフォーカスするとカーソルが表示される問題を修正
      const $input = this._$(this.$refs.prefectureSelect.$el.querySelector('input[type="text"]'))
      $input.css('pointer-events', 'none')
      $input.on('focus', event => event.currentTarget.blur())
    }
  },
  methods: {
    change: function () {
      if (typeof this.changeAction === 'function') {
        this.changeAction()
      }
      this.$emit('input', this.modelValue)
      this.$emit('change', this.modelValue)
    }
  },
  watch: {
    value () {
      this.modelValue = this.value
    }
  }
}
</script>
